const ToastService = {

    // Este metodo lo que hace es configurar como "plugin global" a las instancias 
    // de vue que se esten utilizando.
    install(Vue, options) {

        this.store = options.store;

        const toastService = {
            show: (message, options) => {
                this.store.toastService.message = toastService.format(message);
                this.store.toastService.active = true;
                this.store.toastService.color = options.color || "";
            },
            success: (message) => {
                toastService.show(message, { color: "success" });
            },
            error: (message) => {
                toastService.show(message, { color: "error" });

            },
            warning: (message) => {
                toastService.show(message, { color: "warning" });
            },
            info: (message) => {
                toastService.show(message, { color: "info" });
            },
            format: (payload) => {
                if (!payload) return "Error";

                // Si ya es string
                if (typeof payload === "string") return payload;

                // Axios a veces manda blob/arraybuffer, por las dudas
                if (payload instanceof Blob) return "Error";

                // { errors: [...] }
                const errs = payload.errors;
                if (Array.isArray(errs) && errs.length > 0) {
                    return errs
                        .filter(Boolean)
                        .map((e, i) => `${i + 1}. ${e}`)
                        .join("\n");
                }

                // { message: "..." } o similares
                if (typeof payload.message === "string" && payload.message.trim()) return payload.message;
                if (typeof payload.title === "string" && payload.title.trim()) return payload.title;

                // Último recurso
                try {
                    return JSON.stringify(payload);
                } catch {
                    return "Error";
                }
            }


        };

        Vue.prototype.$toast = toastService;

    }
};

export default ToastService;